<template>
  <div
    style="position: relative;"
    class='grid-filter-sort-dialog'
  >
    <v-menu
      offset-y
      :value="showDropdown"
      :close-on-content-click="false"
      :max-width="300"
    >
      <template v-slot:activator="{ on }">
        <v-btn class="gridHeaderCellMenuDropdown" v-on="on" @click="$emit('toggleDropdown')" text icon color="grey" small>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-card class="pa-5">
        <v-container>
          <v-layout row wrap>                    
            <v-flex xs12 mb-1>
              Sort
            </v-flex>
            <v-flex xs12>
              <v-select
                clearable
                v-model.lazy="selected.order"
                :items="[{text:'Ascending',value:'asc'},{text:'Descending',value:'desc'}]"
                :label="'Sort '+label "
                solo
              >
                <template v-slot:prepend-inner>
                  <v-icon>{{selected.order=='desc'?'mdi-arrow-down':selected.order=='asc'?'mdi-arrow-up':'mdi-view-headline'}}</v-icon>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 mb-1>
              Filter Operator
            </v-flex>
            <v-flex xs12>
              <v-select clearable v-model.lazy="selected.operator" :items="availableOperators" label="Select an operator" solo >
              </v-select>
              <v-text-field clearable v-model.lazy="selected.value" label="Value" ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center controls" >
              <v-btn block class="mb-3" outlined color="primary" @click="applyFilter">Apply</v-btn>                
              <v-layout>
                <v-flex style="padding-right:5px;"> <v-btn text block @click="cancelFilter">Reset</v-btn> </v-flex>
                <v-flex style="padding-left:5px;"> <v-btn block @click="$emit('toggleDropdown')">Close</v-btn></v-flex>
              </v-layout>
              
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
export default {
  props:[
    'showDropdown',
    'label',
    'sortOrder'
  ],
  data(){
    return {
      availableOperators:[
        {text:'Equals (=)',value:'equals'},
        // {text:'Different (!=)',value:'!='},
        {text:'Greater-than (>)',value:'gt'},
        {text:'Greater or Equal than (>=)',value:'gte'},
        {text:'Lower-than (<)',value:'lt'},
        {text:'Lower or Equal than (<=',value:'lte'},
        {text:'Contains',value:'icontains'},
      ],
      emptySelected : { order:'', value:'', operator:'' },
      selected:{ order:'', value:'', operator:'' }
    }
  },
  mounted(){
    this.selected.order = this.sortOrder
  },
  watch : {
    sortOrder (vnew,vold){
      this.selected.order = this.sortOrder
    }
  },
  methods:{
    applyFilter(){
      this.$emit('apply',this.selected)
    },
    cancelFilter(){
      this.selected = _.cloneDeep(this.emptySelected)
      this.applyFilter()
    }
  },
}
</script>

